var BetModel = /** @class */ (function () {
    function BetModel(source) {
        this.id = source.id;
    }
    return BetModel;
}());
export { BetModel };
//# sourceMappingURL=BetModel.js.map